import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ORANGE = "#E8470A";

export function NearbyDestinations({ destinations }) {
  if (!destinations || destinations.length === 0) return null;

  return (
    <section style={{ padding: "40px 0 24px" }}>

      <motion.div
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true, margin: "-80px" }}
        style={{ marginBottom: "32px" }}
      >
        <span style={{
          display: "block",
          color: ORANGE,
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.28em",
          textTransform: "uppercase",
          marginBottom: "12px",
        }}>
          Seguí explorando
        </span>
        <h2 style={{
          fontSize: "clamp(22px, 3vw, 30px)",
          fontWeight: 800,
          color: "#111827",
          lineHeight: 1.2,
          margin: 0,
        }}>
          Destinos que también te pueden interesar
        </h2>
      </motion.div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
        gap: "20px",
      }}>
        {destinations.map((dest, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
            viewport={{ once: true, margin: "-50px" }}
          >
            <Link
              to={dest.href || "#"}
              style={{ display: "block", textDecoration: "none" }}
            >
              <div style={{
                borderRadius: "16px",
                overflow: "hidden",
                border: "1px solid #ede8df",
                boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                backgroundColor: "#ffffff",
                transition: "box-shadow 0.2s",
              }}>
                {/* Image */}
                {dest.image && (
                  <div style={{ position: "relative", height: "180px", overflow: "hidden" }}>
                    <img
                      src={dest.image}
                      alt={dest.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                    {/* Strong overlay to ensure title is readable regardless of image content */}
                    <div style={{
                      position: "absolute",
                      inset: 0,
                      background: "linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0.35) 100%)",
                    }} />
                    <div style={{
                      position: "absolute",
                      bottom: "16px",
                      left: "16px",
                      right: "16px",
                    }}>
                      <h3 style={{
                        fontSize: "22px",
                        fontWeight: 800,
                        color: "#ffffff",
                        margin: 0,
                        lineHeight: 1.1,
                        textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                      }}>
                        {dest.name}
                      </h3>
                    </div>
                  </div>
                )}

                {/* No image fallback */}
                {!dest.image && (
                  <div style={{
                    height: "80px",
                    background: "linear-gradient(135deg, #172033, #1E2A3B)",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 20px",
                  }}>
                    <h3 style={{ fontSize: "20px", fontWeight: 800, color: "#fff", margin: 0 }}>
                      {dest.name}
                    </h3>
                  </div>
                )}

                {/* Body */}
                <div style={{ padding: "16px 20px 20px" }}>
                  {dest.description && (
                    <p style={{
                      fontSize: "14px",
                      lineHeight: 1.6,
                      color: "#6B7280",
                      margin: "0 0 12px",
                    }}>
                      {dest.description}
                    </p>
                  )}
                  <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    color: ORANGE,
                    fontSize: "14px",
                    fontWeight: 600,
                  }}>
                    Ver destino →
                  </span>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
